import { css } from '@emotion/css';
import { modalStyles } from '../modalStyles';

export const styles = {
  container: modalStyles.container,
  fixedSection: modalStyles.fixedSection,
  body: modalStyles.modalContent,
  imageWrapper: css(modalStyles.imageWrapper),
  surface: css`
    max-width: 100%;
  `,
  contentSized: css`
    height: auto;
    max-height: 95dvh;
    @media (max-width: 668px) {
      height: auto;
      max-height: 100dvh;
    }
  `,
  compactBackdrop: css`
    overflow: auto;
    display: flex;
    flex-direction: column;
  `,
  compactSurface: css`
    overflow: visible;
    height: auto;
    max-height: none;
    flex-shrink: 0;
    position: relative;
    bottom: auto;
    margin: auto;
    @media (max-width: 668px) {
      height: auto;
      max-height: none;
    }
  `,
  compactBody: css`
    flex: 0 1 auto;
    /* Keep popovers visible regardless of when COSMA's body styles load. */
    && {
      overflow: visible;
    }
  `,
};
